import {field} from "../../../../generic/tables";
import {Button, Col, PopoverBody, Row, UncontrolledPopover} from "reactstrap";
import dayjs from "dayjs";
import React from "react";
import moment from "dayjs";
import {LoadBadge} from "../../../../generic/badges";
import {CopyLink} from "../../../../generic/buttons";
import {FaRegCommentAlt, FaTrash} from "react-icons/fa";
import StatusIndicator from "../../../../generic/statusIndicator/StatusIndicator";
import {AdventureRemoveRuleProvider} from "../../../RuleProvider";
import {ElementWithPermissions} from "../../../../common/formElements";
import {getPermissions} from "../../../../../lib/utils/hooks/useRoleSystem";
import {getPermissionEntity} from "./helpers";

export const arrivalFields = (mode, getArrivalUrl, deleteArrival, typeForRule, isSchool) => {
    const isLinked = mode === 'lower';
    const resSelector = res => isLinked  ? res.linked_arrival_id : res;

    return [
        field("Заезд", true, "start_date", res => {
            const target = resSelector(res);
            return (
                <Row>
                    <Col xs={12}>
                        {target.start_date ?
                            dayjs(res.start_date).format('DD.MM.YYYY - ') + dayjs(res.end_date).format('DD.MM.YYYY') :
                            '-'
                        }
                    </Col>
                </Row>
            )
        }),
        ...(isSchool ? [
            field("Время старта", true, "start_time", res => {
                const target = resSelector(res);
                return (
                    <Row>
                        <Col>{target.start_time ? moment(target.start_time, 'HH:mm').format('HH:mm') : '-'}</Col>
                    </Row>
                )
            })
        ] : []),
        field("Имя", true, "name", res => {
            const target = resSelector(res);
            return <Row><Col>{target.name}</Col></Row>
        }),
        field("Цена", true, "price_value", res => {
            const target = resSelector(res);
            return <Row><Col>{target.price_value} {target.price_currency}</Col></Row>;
        }),
        field("Записи", true, "booked_to_total", res => {
            const target = resSelector(res);
            return (
                <Row>
                    <Col className={mode === "upper" ? "mt-0" : ""}>
                        {target.booked_sits} {` (${target.total_sits - target.booked_sits - target.available_reserved_sits}) `} / {target.total_sits}
                        <LoadBadge value={target.booked_to_total}/>
                    </Col>
                </Row>
            );
        }),
        field("Ссылка", false, "url", res => {
            const target = resSelector(res);
            return <CopyLink showLink={false} href={getArrivalUrl(target)}/>;
        }),
        field("", false, "comment", res => {
            const target = resSelector(res);
            const comment = mode === "single" ? target?.comments_for_manager?.[0]?.text : target.comment;
            return (
                <Row>
                    <Col>
                        {!!comment && <>
                            <FaRegCommentAlt id={"comment-" + target.id}/>
                            <UncontrolledPopover placement="left" target={"comment-" + target.id} trigger={'hover'}>
                                <PopoverBody>{comment}</PopoverBody>
                            </UncontrolledPopover>
                        </>}
                    </Col>
                </Row>
            );
        }),
        field("Статус", false, "status", res => {
            const target = resSelector(res);
            return <Row><Col><StatusIndicator res={target}/></Col></Row>;
        }),
        field("", false, "comment", res => {
            const target = resSelector(res);
            return (
                <AdventureRemoveRuleProvider typeForRule={typeForRule} isArrivals>
                    <Row>
                        <Col>
                            <div className="btn-group">
                                <ElementWithPermissions disabled={!getPermissions(getPermissionEntity(target.adventure_id)).edit}>
                                    <Button color="danger" size="xs" onClick={() => deleteArrival(target)}>
                                        <FaTrash/>
                                    </Button>
                                </ElementWithPermissions>
                            </div>
                        </Col>
                    </Row>
                </AdventureRemoveRuleProvider>
            );
        }),
    ]
}